import firebase from 'firebase';

// Import the CRUD operations for firebase
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCmIBJ6Iy1qOJLPe72mbAoq2jfD4NsUSxg",
  authDomain: "access-db-8a356.firebaseapp.com",
  databaseURL: "https://access-db-8a356.firebaseio.com",
  projectId: "access-db-8a356",
  storageBucket: "access-db-8a356.appspot.com",
  messagingSenderId: "75579590171",
  appId: "1:75579590171:web:fee61724bfb5f875fa9abe",
  measurementId: "G-R2S2XTRM3K"
};

const Firebase = firebase.initializeApp(firebaseConfig);

// Create and instance of the firestore database
export const db = firebase.firestore();

// avoid deprecated warnings
// db.settings({
//   timestampsInSnapshots: true
// })

export default Firebase;